// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6633319b","239":"6c967776","732":"34b104ca"}[chunkId] + ".chunk.js";
};